// Function to toggle body class for each nav toggle
function toggleNavClass( querySelector ) {
	document.querySelectorAll( querySelector ).forEach( ( node ) => {
		node.addEventListener( 'click', () => {
			if ( document.body.classList.contains( 'is-search' ) ) {
				document.body.classList.remove( 'is-search' );
			} else {
				document.body.classList.add( 'is-search' );
			}
			if ( node.ariaExpanded === 'true' ) {
				node.ariaExpanded = 'false';
			} else {
				node.ariaExpanded = 'true';
			}
		} );
	} );
}

// Call toggleNavClass for elements with specific class
toggleNavClass( '.search-toggle .search-toggle__btn' );
